import React, { Component } from 'react'
import { regionLocales } from '../../dashboard/data/locales'
import { DEFAULT_LOCALE } from '../../dashboard/constants'

class Language extends Component {
  constructor(props) {
    super(props)

    this.state = {
      opened: false
    }

    this.close = this.close.bind(this)
  }

  openHandler(e) {
    e.preventDefault()

    if (this.state.opened) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    document.addEventListener('click', this.close)
    this.setState({ opened: true })
  }

  close() {
    this.setState({ opened: false })
    document.removeEventListener('click', this.close)
  }

  currentLocale() {
    const { region, locale } = this.props
    let language = regionLocales[region].find(el => el.code === locale)

    if (!language) {
      language = regionLocales[region][0]
      const url = (language.code === DEFAULT_LOCALE) ? '/login' : `/${language.code}/login`
      window.location = url
      return
    }

    return language
  }

  render() {
    const renderLocales = regionLocales[this.props.region].map(locale => {
      const url = (locale.code === DEFAULT_LOCALE) ? '/login' : `/${locale.code}/login`
      const activeClass = locale.code === this.props.locale ? 'active' : ''

      return (
        <li key={locale.code} className={`${activeClass} ${locale.code} flag`}>
          <a href={url}>{locale.name}</a>
        </li>
      )
    })

    return (
      <div
        className={`flag ${this.currentLocale().code}`}
      >
        <a
          href=""
          className="dropdown-toggle"
          onClick={this.openHandler.bind(this)}
        >
          {this.currentLocale().name} <span className="caret"></span>
      </a>

        { this.state.opened &&
          <ul className="dropdown-menu">
            {renderLocales}
          </ul>
        }
      </div>
    )
  }
}

export default Language



// WEBPACK FOOTER //
// ./app/javascript/components/application/layout/language.js